import React from "react";

import { FiArrowLeft } from "react-icons/fi";

const AccountSelectionPage = ({
  bankAccounts,
  selectedAccountId,
  setSelectedAccountId,

  getBank,

  // openAddBankFromAa,

  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--bank fw-fade">
      <div className="fw-bank-top">
        <button
          type="button"
          className="fw-bank-back"
          onClick={() => setScreen("/apply-new/aaMobile")}
          aria-label="Back"
        >
          <FiArrowLeft />
        </button>

        <h1>Account Aggregator Verification testd</h1>
      </div>

      <p className="fw-bank-label">
        Choose the Bank Account you wish to use.
      </p>

      <div className="fw-bank-scroll">
        {bankAccounts.map((account) => {
          const bank = getBank(account.bankId);

          return (
            <button
              key={account.id}
              type="button"
              className={`fw-account-card ${
                selectedAccountId === account.id
                  ? "is-selected"
                  : ""
              }`}
              onClick={() =>
                setSelectedAccountId(account.id)
              }
            >
              <span
                className="fw-bank-logo fw-bank-logo--sm"
                style={{
                  background: bank.color,
                }}
              >
                {bank.name.charAt(0)}
              </span>

              <div>
                <strong>{bank.name}</strong>

                <small>
                  {account.type} {account.masked}
                </small>
              </div>

              <span className="fw-account-card__radio" />
            </button>
          );
        })}
      </div>

      <div className="fw-screen__footer fw-bank-footer-stack">
        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={() => setScreen("/apply-new/aaConsent")}
        >
          Proceed
        </button>

        {/* <button
          type="button"
          className="fw-btn fw-btn--soft fw-btn--full"
          onClick={openAddBankFromAa}
        >
          Add Another Account
        </button> */}
      </div>

      <p className="fw-powered">
        Powered by <b>FUNDSWALLE</b>
      </p>
    </section>
  );
};  

export default AccountSelectionPage;